/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_New_Create_BtnInputs */



/**
* | output |
* | --- |
* | "Create Tournament" |
*
* @param {Tournament_New_Create_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_new_create_btn = /** @type {((inputs?: Tournament_New_Create_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_New_Create_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer le tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criar Torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea Torneo")
	return /** @type {LocalizedString} */ ("Create Tournament")
});